/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Damage_TypeInputs */

const en_case_field_damage_type = /** @type {(inputs: Case_Field_Damage_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value type`)
};

const pt_br2_case_field_damage_type = /** @type {(inputs: Case_Field_Damage_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de valor`)
};

/**
* | output |
* | --- |
* | "Value type" |
*
* @param {Case_Field_Damage_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_damage_type = /** @type {((inputs?: Case_Field_Damage_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Damage_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_damage_type(inputs)
	return pt_br2_case_field_damage_type(inputs)
});